/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

export const SPLASH_SETTINGS = {
  counterInit: 0,
  count: 4,
  limit: 100,
  interval: 50,
};
